import Vue from "vue";

/**
 * Class Coupon Service
 */
export default class CouponService extends Vue {
  private customActions = {
      indexStatus: { method: 'GET', url: 'lead/platform/coupon/status/{statusName}' },
  };
  private resource: any = this.$resource(
    "lead/platform/coupon",
    {},
    this.customActions
  );

  // GET all
  public index() {
    return this.resource.get().then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }
    
  public store(code: string, discount: number, statusName: string) {
    return this.resource.save({ code, discount, statusName }).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
}

  public update(couponID:number, code: string, statusName: string, discount?: number,) {
    return this.resource.update({ couponID, code, statusName, discount }).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  // GET all with statusName
  public indexStatus(statusName: string) {
    return this.resource.indexStatus({ statusName });
  }
}
